import { useCallback, useState } from 'react';
export function useLocalStorage(key, defaultState) {
    const [value, setValue] = useState(() => {
        const value = localStorage.getItem(key);
        if (value)
            return JSON.parse(value);
        return defaultState;
    });
    const setLocalStorage = useCallback((newValue) => {
        if (newValue === value)
            return;
        setValue(newValue);
        if (newValue === null) {
            localStorage.removeItem(key);
        }
        else {
            localStorage.setItem(key, JSON.stringify(newValue));
        }
    }, [value, setValue, key]);
    return [value, setLocalStorage];
}
//# sourceMappingURL=useLocalStorage.js.map